var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.statsCards),function(stats){return _c('div',{key:stats.type,staticClass:"col-lg-3 col-md-6 col-sm-6"},[(stats.permissions.includes(_vm.userType))?_c('stats-card',{attrs:{"type":stats.type,"icon":stats.icon,"small-title":stats.title,"title":stats.value}}):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }